import React from "react";

/**
 * NestedItemCard - A reusable component for displaying nested items within main cards
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display in the card
 * @param {boolean} props.hover - Whether to show hover effects (default: true)
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 */
const NestedItemCard = ({
  children,
  hover = true,
  className = "",
  style = {},
}) => {
  const baseClasses =
    "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 card-inset";
  const hoverClasses = hover ? "hover:bg-brand-cream transition-colors" : "";

  return (
    <div
      className={`${baseClasses} ${hoverClasses} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default NestedItemCard;
